<cx-searchbox
  [quickOrder]="true"
  [searchValueClear]="clearSearchValue"
  (selectedProductEvent)="onProductSelected($event)"
  [config]="QUICKORDER_SEARCH_BOX_CONFIG">
</cx-searchbox>

@if (quickOrderDetail) {
  <div class="mt-2 mb-4">
    <!-- Conract -->
    <div class="row">
      @if (selectedChannel === PriceChannel.PUBLIC) {
        <div class="col-md-12">
          @if (showContract && showContractList) {
            <p class="font-bold mt-3 mb-2">
              {{ 'plp.contracts' | cxTranslate }}
            </p>
            <app-contract
              class="w-100"
              [conditions]="productConditions"
              (contractSelectedEvent)="showSelectedContract($event)" />
          } @else if (showContract && !showContractList && contractSelected) {
            <p class="mt-3 mb-2">
              {{ contractSelected.contractId }} ({{
                contractSelected.contractName
              }})
            </p>
          }
        </div>
      }
      <!-- Price Group -->
      @if (contractSelected?.priceGroups?.length > 1 || showPriceGroup) {
        <div class="col-md-12">
          <p class="font-bold mt-3 mb-2">
            {{ 'plp.priceGroup' | cxTranslate }}
          </p>
          <app-contract-price-group
            [priceGroup]="priceGroupToShow"
            (priceGroupSelectedEvent)="showSelectPriceGroup($event)" />
        </div>
      }
    </div>
    <!-- Price / Unit -->
    <div class="unit-calc">
      <div class="d-flex justify-content-around w-100 mb-4 mt-4">
        <div class="price-details">
          <div
            class="mb-2 text-fixed-legal-copy color-grey-dark font-weight-bold">
            {{ 'plp.yourPrice' | cxTranslate }}
          </div>

          <div class="c-heading c-heading-h3">
            @if (!checkIfUnavailableToOrder()) {
              <span>{{ productInfo?.price?.formattedValue }}</span>
            }

            @if (
              showContract &&
              contractSelected &&
              priceToShow &&
              selectedChannel === PriceChannel.PUBLIC
            ) {
              <span>{{ priceToShow | localCurrency }}</span>
            }
          </div>
        </div>

        @if (!productInfo?.discontinued && productInfo?.available) {
          <div class="units">
            <label
              class="mb-2 text-center text-fixed-legal-copy font-weight-bold color-grey-dark"
              for="{{ 'prodQuantity' + productInfo.code + 'q' }}">
              {{ 'plp.units' | cxTranslate }}
            </label>
            <div class="d-flex justify-content-center align-items-center">
              <span
                id="{{ 'unitMinus' + productInfo?.code + 'q' }}"
                class="d-none"></span>
              <span
                id="{{ 'unitMinusDisable' + productInfo?.code + 'q' }}"
                class="d-none"></span>
              <span
                id="{{ 'unitPlus' + productInfo?.code + 'q' }}"
                class="d-none"></span>
              <span
                id="{{ 'unitPlusDisable' + productInfo?.code + 'q' }}"
                class="d-none"></span>

              <button
                class="c-count-change-btn disabled"
                id="{{ 'minusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(2)">
                <i class="fa fa-minus" aria-hidden="true"></i>
              </button>
              <input
                type="number"
                class="prod-quantity text-center"
                value="{{
                  conditionsForCartonsLogicMeet
                    ? productInfo.numberOfUnitsPerCarton
                    : '1'
                }}"
                (blur)="performQuantityComputation(null)"
                id="{{ 'prodQuantity' + productInfo.code + 'q' }}"
                min="1"
                max="{{ ProductUtils.getMaximumQuantity(selectedChannel) }}" />
              <button
                class="c-count-change-btn"
                id="{{ 'plusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(1)">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>

            @if (conditionsForCartonsLogicMeet) {
              <div
                class="w-100 mt-1 d-flex justify-content-center text-center"
                id="{{ 'noOfCartons' + productInfo?.code + 'q' }}">
                <span class="red">min 1 cx embarque</span>
              </div>
            }
          </div>
        }
      </div>
      <!-- Dynamic Add to cart Button -->
      @if (checkIfProductCanBeAddedToTheCart()) {
        <button
          type="button"
          class="c-button c-button--primary quickorder-button"
          [ngbPopover]="popTitleSuccess"
          placement="bottom"
          triggers="manual"
          #p2="ngbPopover"
          popoverClass="savesuccess-msg"
          [closeDelay]="500"
          (click)="addToCart(productInfo?.code + 'q', productInfo?.code)"
          id="prod-{{ productInfo?.code }}">
          <ng-template #popTitleSuccess>
            <div class="cart-value-added">
              <img
                src="../../../assets/icons/confirmation-positive-green.png"
                class="positive-green-icon"
                alt="suc" />
              <span class="confirmation-itemsadded"
                >{{ itemAddedQuantity }}
                {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}</span
              >
            </div>
          </ng-template>

          @if (this.productInfo?.flu) {
            <i class="fa fa-calendar" aria-hidden="true"></i>
          }
          {{
            (this.productInfo?.flu
              ? 'addToCartItems.reserveNow'
              : 'addToCartItems.addCart'
            ) | cxTranslate
          }}
        </button>
      }

      @if (!productInfo?.discontinued && productInfo?.available) {
        <section>
          @if (productInfo.sapAllocation) {
            <section>
              <b class="prod-allocation">{{
                'plp.productAllocation' | cxTranslate
              }}</b>
              <p class="allocation-p">
                {{ 'plp.allocationDetails' | cxTranslate }}
              </p>
            </section>
          }
        </section>
      }
    </div>

    @if (productInfo?.discontinued || !productInfo?.available) {
      <section>
        @if (productInfo?.discontinued && productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">
              {{ 'plp.discontinued' | cxTranslate }}
            </p>
          </section>
        }

        @if (productInfo?.discontinued && !productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">
              {{ 'plp.discontinued' | cxTranslate }}
            </p>
          </section>
        }

        @if (!productInfo.discontinued && !productInfo.available) {
          <section class="m0 left-align">
            @if (productInfo.availabilityText) {
              <b class="prod-allocation class-avail">{{
                productInfo.availabilityText
              }}</b>
            } @else {
              <b class="prod-allocation class-avail">{{
                'plp.noavailabilityText' | cxTranslate
              }}</b>
            }
          </section>
        }
      </section>
    }

    @if (checkIfUnavailableToOrder()) {
      <button type="button" class="c-button c-button--primary w-100" disabled>
        {{ 'plp.unavailableToOrder' | cxTranslate }}
      </button>
    }
  </div>
}
